import { EmoticonIcon } from './EmoticonIcon';

/**
 * author: Google
 * id E8F2B8BE-F4EC-4B9C-BB15-001752B29FFD
 * name emoticon
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon.svg
 * tags
 * - Emoji 
 */
export const EmojiIcon = EmoticonIcon;
export default EmojiIcon